import { SubscriptionFeature } from "./SubscriptionFeatures";

export class SubscriptionPlan
{
    Id: number;
    Name: string;
    Description: string;
    Enabled: boolean;
    Price: number;
    LengthInMonths: number;
    UserLimit: number;
    DateUpdatedUtc: Date;
    UpdatedByUserId: string;
    SubscriptionFeatures: SubscriptionFeature;
	TotalPrice: number;
	DiscountPercentage: number;
	RewardDiscountPercentage: number;
	TrialPeriod: number;
}

export class CreateSubsciptionPlan
{
    Name: string;
    Description: string;
    Enabled: boolean;
    PricePerMonth: number;
    LengthInMonths: number;
    UserLimit: number;
	DiscountPercentage: number;
	RewardDiscountPercentage: number;
	TrialPeriod: number;
}

export class UpdateSubsciptionPlan extends CreateSubsciptionPlan
{
    Id: number;
    constructor(item?: SubscriptionPlan) {
        super();
        this.Id = item.Id;
        this.Name = item.Name;
        this.Description = item.Description;
		this.Enabled = item.Enabled
        this.PricePerMonth = item.Price;
        this.LengthInMonths = item.LengthInMonths;
        this.UserLimit = item.UserLimit;
        this.DiscountPercentage = item.DiscountPercentage;
        this.RewardDiscountPercentage = item.RewardDiscountPercentage;
		this.TrialPeriod = item.TrialPeriod;
    }

}


export  class UpdateUserSubscription {
	PlanId: number;
	UserId: string;
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/Subscription.ts